import { Button, Heading } from '@wix/design-system'
import { useContent } from '@wix/funnel-builder-lizard'
import { ArrowRight, Confirm } from '@wix/wix-ui-icons-common/lazy'
import React, { FC, useEffect } from 'react'

import { usePageLogger } from '../../../bi/mfi'
import { useNext } from '../../../hooks/useNext'
import { EnterpriseLayout } from '../EnterpriseLayout'
import { TEnterpriseFormThanks as Content } from './EnterpriseFormThanks.content'
import s from './EnterpriseFormThanks.scss'

export const EnterpriseFormThanks: FC = () => {
  const page = useContent<Content>()
  const next = useNext()
  const pageLogger = usePageLogger()
  const { questionKey, content, options } = page.content.question

  useEffect(() => {
    pageLogger.screenView()
  }, [pageLogger])

  const handleNext = (optionKey: string) => {
    next({ [questionKey]: { values: [optionKey] } })
    pageLogger.answer({ answer: optionKey })
  }

  return (
    <EnterpriseLayout>
      <div className={s.wrapper}>
        <div className={s.titles}>
          <Confirm width="60px" height="60px" />
          <Heading className={s.title}>{content.title}</Heading>
          <Heading className={s.subtitle}>{content.subtitle}</Heading>
        </div>
        <div className={s.options}>
          {options.map(option => (
            <Button
              skin="dark"
              priority="secondary"
              suffixIcon={<ArrowRight />}
              key={option.optionKey}
              onClick={() => handleNext(option.optionKey)}
              size="large"
            >
              {option.title}
            </Button>
          ))}
        </div>
      </div>
    </EnterpriseLayout>
  )
}
